export class RefundData {

  public id: number;
  public amount: string;
  public dateCreated: string;
  public reason: string;
  public lineItems: any;

}
